module.exports = __webpack_public_path__ + "files/570dd92d9e5d824654b78456e996e3d2.png";